export const ROLE = ()=>{
  const user = JSON.parse(localStorage.getItem('user'));
  return user.role;
}

export const USER = ()=>{
  const user = JSON.parse(localStorage.getItem('user'));
  return user;
}

export const USERNAME = ()=>{
  const user = JSON.parse(localStorage.getItem('user'));
  return user.username;
}

export const PASSWORD = (password)=>{
  const user = JSON.parse(localStorage.getItem('user'));
  let check = user.password !== password ? false : true;
  return check;
}
